export default {
  rootGrid: {
    flexGrow: 1,
    marginTop: 20,
  },
  title: {
    textAlign: 'center',
  },
  instructions: {
    textAlign: 'center',
  },
}
